import React from 'react';
import styles from './css/index.module.css';
import createdCheck from './assets/created-check.svg';

const CreateProjectCreated = ({ onSetup, onSkip }) => (
    <div className={styles.card}>
        <div className={styles.createdBody}>
            <div className={styles.createdIconWrap} aria-hidden="true">
                <img src={createdCheck} alt="" width={24} height={20} className={styles.createdCheck} />
            </div>
            <h1 className={styles.createdTitle}>Project created</h1>
            <p className={styles.createdSubtitle}>Now let&apos;s prepare the project workspace.</p>
            <div className={styles.createdActions}>
                <button type="button" className={styles.primaryButton} onClick={onSetup}>
                    Set up project workspace
                </button>
                <button type="button" className={styles.ghostButton} onClick={onSkip}>
                    Skip and enter project workspace
                </button>
            </div>
        </div>
    </div>
);

export default CreateProjectCreated;
